<mat-expansion-panel
	#sectionPanel
	[expanded]="expanded()"
	class="au-section-panel"
	hideToggle
>
	<mat-expansion-panel-header class="section-header">
		<mat-panel-title>
			@if (showSectionIcon) {
				<span [class.rotate-right-90]="!sectionPanel.expanded" class="arrow">
					<mat-icon svgIcon="arrow_down" />
				</span>
			}
			@if (title) {
				<span class="section-name">{{ title }}</span>
			}
			@if (series()?.length) {
				<div class="sections-counter">
					{{ series().length }}
				</div>
			}
			<ng-content select="[title-element]"></ng-content>
		</mat-panel-title>
	</mat-expansion-panel-header>

	<div class="expansion-body">
		@if (showNewGraphComponent()) {
			<mat-card>
				<new-time-series-settings-form
					(closeNewGraphSettings)="closeNewGraphComponent()"
					(submitNewTimeSeriesSettings)="createNewChart($event)"
				></new-time-series-settings-form>
			</mat-card>
		}

		@for (chart of series(); track chart.id; let index = $index) {
			<mat-card>
				<mat-expansion-panel class="au-section-panel no-padding" hideToggle>
					<mat-expansion-panel-header class="section-header">
						<mat-panel-title class="section-header-title">
							@let lastValueInSequence = getLastTimeSeriesElement(chart);
							<div class="card-left">
								<span class="section-name">
									{{ chart.name }}
								</span>
								<div class="section-name-value">
									<div class="section-value">
										{{ lastValueInSequence?.value || 0 }}
										{{ chart?.settings?.unit ?? '' }}
									</div>

									<button
										class="au-add-fab-button"
										matTooltip="{{ 'add_new_value' | translate }}"
										(click)="openAddValueDialog(chart, $event)"
										matRipple
										matRippleColor="rgba(#1c4b31, 0.05)"
									>
										<mat-icon class="accent-icon" svgIcon="add">add</mat-icon>
									</button>
								</div>
							</div>
							<div class="card-right">
								<div class="graph-panel-title-elements-wrapper">
									@if (lastValueInSequence) {
										<span class="avatar-date-wrapper">
											<au-round-avatar
												[data]="{
													smallAvatarUrl: lastValueInSequence?.createdBy.smallAvatarUrl,
													firstName: lastValueInSequence?.createdBy.firstName,
													lastName: lastValueInSequence?.createdBy.lastName,
												}"
												[matTooltip]="
													lastValueInSequence?.createdBy.firstName +
													' ' +
													lastValueInSequence?.createdBy.lastName
												"
												[size]="35"
											></au-round-avatar>
										</span>
									}
								</div>

								<span class="last-value-in-sequence-label">{{
									lastValueInSequence?.created | date: 'MMM d, HH:mm'
								}}</span>

								<div
									[matMenuTriggerFor]="deleteBtnMenu"
									[matRippleCentered]="true"
									class="section-menu-icon-wrapper icon-wrapper"
									matRipple
									matRippleColor="rgba(#1c4b31, 0.05)"
									(click)="$event.stopPropagation()"
								>
									<mat-icon class="secondary-text-icon">more_vert</mat-icon>
								</div>

								<mat-menu
									#deleteBtnMenu="matMenu"
									class="actions-menu"
									xPosition="before"
								>
									<button (click)="editChartName(chart)" mat-menu-item>
										<mat-icon class="primary-grey" svgIcon="edit" />
										<span class="button-edit">{{
											'edit_component_name' | translate
										}}</span>
									</button>

									<button (click)="deleteChart(chart)" mat-menu-item>
										<mat-icon class="critical-icon" svgIcon="delete" />
										<span class="button-delete">{{
											'delete_component' | translate
										}}</span>
									</button>
								</mat-menu>
							</div>
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="chart-section-wrapper">
						<chart-section
							[chart]="chart"
							(openAddValue)="openAddValueDialog(chart)"
						></chart-section>
					</div>
				</mat-expansion-panel>
			</mat-card>
		}

		@if (!series()?.length && !showNewGraphComponent()) {
			<h5 class="no-graphs-yet-label">{{ 'add_component_instruction' | translate }}</h5>
		}
	</div>
</mat-expansion-panel>

@if (editChartNameModalVisible) {
	<div class="graph-cloak"></div>
}
@if (editChartNameModalVisible) {
	<div class="edit-point-modal">
		<edit-section-name-modal
			(closeEmitted)="closeEditChartNameModal()"
			(saveEmitted)="saveNewChartName($event)"
			[data]="editChartNameValue"
		></edit-section-name-modal>
	</div>
}
